<forge-chip-set fxLayout="row" fxLayoutAlign="end center" readonly="true" type="action">
    <ng-container *ngFor="let chip of chips">
        <forge-chip *ngIf="chip.isVisible" (click)="chip.action($event)" telemetry="Submission-{{chip.label}}">
            {{chip.label}}
        </forge-chip>
    </ng-container>
</forge-chip-set>